module.exports = __webpack_public_path__ + "crypto_icon.png?0302d2d743c3635813f935318ed68556";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crypto_icon.png
// module id = 839
// module chunks = 2